import './Intro.css'
export const Intro=()=>{
    return(<div className='Intro margin-top-mobile'>
        <p className="first">Hi, I'm</p>
        <p className="full-name"> Akshay Bhandary.</p>
        <p className="job-profile"> I create great digital experiences.</p>
    </div>);
}